import React, { useState } from "react";
import jobs from './assets/jobs.jpg';
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import { useLocation } from "react-router-dom";
import { applyJob } from "./services/authService";
import { toast } from "react-toastify";
import LinkedIn from "./assets/logo/LinkedIn.png";
import twitter from "./assets/logo/twitter.png";
import insta from "./assets/logo/insta.png";
import fb from "./assets/logo/fb.png";

function JobPost() {
  const location = useLocation();
const job = location.state;
const [loading, setLoading] = useState(false);


const [formData, setFormData] = useState({
  name: "",
  email: "",
  mobile_no: "",
  linkedin_profile_link: "",
  cover_letter: "",
  resume_doc: null,
});

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};

const handleFileChange = (e) => {
  setFormData((prev) => ({
    ...prev,
    resume_doc: e.target.files[0],
  }));
};
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const data = new FormData();

    data.append("job_id", job?.job_id);
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("mobile_no", formData.mobile_no);
    data.append("linkedin_profile_link", formData.linkedin_profile_link);
    data.append("cover_letter", formData.cover_letter);
    data.append("resume_doc", formData.resume_doc);

    const res = await applyJob(data);

    if (res.success === "1") {
      toast.success(res.message || "Application submitted successfully!");
    } else {
      toast.error(res.message || "Something went wrong ❌");
    }
  } catch (error) {
    console.error("Apply API Error:", error);
    toast.error("API Error ❌");
  }
};

  return (
    <>
      <Navbar />

      <div className="container">
        <div className="title">{job?.job_title}</div>

        <img src={job?.job_image} alt="job" className="hero" />

        {/* META */}
        <div className="meta">
          <div className="meta-label">Department :</div>
          <div className="meta-value">{job?.job_department}</div>

          <div className="meta-label">Location :</div>
          <div className="meta-value">{job?.job_location}</div>

          <div className="meta-label">Employment Type :</div>
          <div className="meta-value">{job?.employment_type}</div>

          <div className="meta-label">Experience Level :</div>
          <div className="meta-value">{job?.experience}</div>

          <div className="meta-label">Posted Date :</div>
          <div className="meta-value">
  {job?.created_at &&
    new Date(job.created_at).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })}
</div>

          <div className="meta-label">Job Description :</div>
          <div className="meta-value description">
            {job?.job_description?.split("\n").map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>

        {/* SKILLS */}
       

        {/* FORM */}
     
      </div>

      <section className="join-section">
  <div className="join-container">

    {/* LEFT TEXT */}
    <div className="join-left">
      <h2>
        Interested in <br /> joining our Team
      </h2>

      <p>
       We are looking for talented individuals. Share your profile with us and we’ll reach out when opportunity arise.
      </p>

      <div className="d-flex gap-3 ">
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={LinkedIn}
                      alt="LinkedIn"
                    />
                  </a>

                  <a
                    href="https://x.com/rolotransit?s=21"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={twitter}
                      alt="Twitter"
                    />
                  </a>

                  <a
                    href="https://www.instagram.com/rolotransit/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={insta}
                      alt="Instagram"
                    />
                  </a>

                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={fb}
                      alt="Facebook"
                    />
                  </a>
                </div>
    </div>

    {/* RIGHT FORM */}
    <div className="join-right">
      <form className="join-form" onSubmit={handleSubmit}>

       <input
  type="text"
  name="name"
  placeholder="*Name"
  onChange={handleChange}
  required
/>

        <div className="form-row">
          <input
  type="email"
  name="email"
  placeholder="*Email"
  onChange={handleChange}
  required
/>
          <input
  type="text"
  name="mobile_no"
  placeholder="Contact Number"
  onChange={handleChange}
  required
/>
        </div>
<input
  type="text"
  name="linkedin_profile_link"
  placeholder="LinkedIn Profile"
  onChange={handleChange}
/>
        <textarea
  name="cover_letter"
  placeholder="*Message"
  onChange={handleChange}
/>

        {/* FILE UPLOAD */}
       <label className="upload-box">
  Attach Your Resume
  <input type="file" hidden onChange={handleFileChange} />
</label>

{formData.resume_doc && (
  <p style={{ color: "#fff", fontSize: "12px" }}>
    Selected: {formData.resume_doc.name}
  </p>
)}

        

        <p className="policy">
          By using this website, you consent to our use of cookies and
          collection of personal data as outlined in our Privacy Policy.
        </p>

        <button type="submit">{loading ? "Submitting..." : "Submit"}</button>
      </form>
    </div>

  </div>
</section>

      <Footer />



      <style>{`
        :root {
          --bg: #000;
          --text: #fff;
          --muted: #aaa;
          --orange: #f97316;
        }

        /* ✅ IMPORTANT RESET */
        body, #root {
          margin: 0;
          padding: 0;
          background: var(--bg);
          color: var(--text);
          font-family: Arial, sans-serif;
        }

        .container {
         
          margin: auto;
          padding: 90px 20px 10px; /* 👈 bottom spacing for footer */
        }

        .title {
          font-size: 28px;
          font-weight: 600;
          color: var(--orange);
          margin-bottom: 30px;
        }

        .hero {
          width: 100%;
          height: 400px;
          border-radius: 10px;
          margin-bottom: 50px;
        }

        .meta {
          display: grid;
          grid-template-columns: 200px 1fr;
          row-gap: 14px;
          column-gap: 20px;
          margin-bottom: 30px;
        }

        .meta-label {
          color: var(--orange);
        }

        .meta-value {
          color: var(--text);
        }

        .description {
          color: var(--muted);
          line-height: 1.6;
          max-width: 800px;
        }

        .section-title {
          margin-top: 30px;
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: 600;
        }



        /* JOIN SECTION */
.join-section {
  background: #000;
  padding: 10px 10%;
}

/* CONTAINER */
.join-container {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 100px;
 
}

/* LEFT SIDE */
.join-left h2 {
  font-size: 56px;
  font-weight: 800;
  color: #FF7F1F;
  line-height: 1.1;
  margin-bottom: 20px;
}

.join-left p {
  font-size: 18px;
  color: #dcdcdc;
  line-height: 1.6;
  max-width: 420px;
}

/* FORM */
.join-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* INPUTS */
.join-form input,
.join-form textarea {
  background: #2b2b2b;
  border: none;
  border-radius: 10px;
  padding: 16px;
  color: #fff;
  font-size: 14px;
  outline: none;
}

/* PLACEHOLDER */
.join-form input::placeholder,
.join-form textarea::placeholder {
  color: #FC9344;
}



/* TEXTAREA */
.join-form textarea {
  height: 120px;
  resize: none;
}
  .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

/* UPLOAD BOX */
.upload-box {
  background: #E6C3A5;
  color: #000;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

/* ICON */
.upload-icon {
  font-size: 18px;
  color: #FF7F1F;
}

/* NOTE TEXT */
.note {
  font-size: 12px;
  color: #aaa;
}

.note span {
  color: #00BFFF;
  cursor: pointer;
}

/* POLICY */
.policy {
  font-size: 11px;
  color: #777;
  line-height: 1.5;
}

/* BUTTON */
.join-form button {
  background: linear-gradient(90deg, #FF7F1F, #FF5A00);
  border: none;
  padding: 16px;
  border-radius: 10px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.join-form button:hover {
  opacity: 0.9;
}

        @media(max-width:768px){
          .meta, .skills {
            grid-template-columns: 1fr;
          }

          .form-row {
            grid-template-columns: 1fr;
          }
              .form-row {
    grid-template-columns: 1fr;
  }
        }
      `}</style>
    </>
  );
}

export default JobPost;